var __vue_script__, __vue_template__
var __vue_styles__ = {}
__vue_script__ = require("!!babel-loader?presets[]=es2015&plugins[]=transform-runtime&comments=false!../../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./index.vue")
if (Object.keys(__vue_script__).some(function (key) { return key !== "default" && key !== "__esModule" })) {
  console.warn("[vue-loader] packages/components/g2/src/index.vue: named exports in *.vue files are ignored.")}
__vue_template__ = require("!!vue-html-loader!../../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./index.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
if (__vue_template__) {
__vue_options__.template = __vue_template__
}
if (!__vue_options__.computed) __vue_options__.computed = {}
Object.keys(__vue_styles__).forEach(function (key) {
var module = __vue_styles__[key]
__vue_options__.computed[key] = function () { return module }
})



//////////////////
// WEBPACK FOOTER
// ./packages/components/g2/src/index.vue
// module id = 1924
// module chunks = 38